import React, { Component } from 'react';
import styled from 'styled-components';
import Section from './Section';
import { device } from '../utils/devices';

const ListBlock = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10vw;

  @media ${device.laptop} {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    height: 50vh;
    padding: 0;
  }
`;

const List = styled.ul`
  list-style: none;
  font-size: 18px;

  @media ${device.laptop} {
    font-size: 30px;
  }
`;

const Item = styled.li`
  line-height: 2em;

  @media ${device.laptop} {
    line-height: 60px;
  }

  &:before {
    content: "\u231D";
    margin-right: .5rem;
  }
`;

export default class Amenities extends Component {
  render(){
    return (
      <Section title='Amenities'>
        <ListBlock>
          <List>
            <Item>1000 square feet</Item>
            <Item>9 foot ceilings</Item>
            <Item>Wifi</Item>
            <Item>Rolling Clothing rack (x2)</Item>
          </List>
          <List>
            <Item>Garment steamer</Item>
            <Item>Hair & Makeup tables</Item>
            <Item>Mini-fridge</Item>
            <Item>Bathroom</Item>
          </List>
        </ListBlock>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Amenities.js